// extracted by css-extract-rspack-plugin
export default {"cls1":"JournalSubscriptionPage-cls1_rWx","cls2":"JournalSubscriptionPage-cls2_NOB JournalSubscriptionPage-cls1_rWx"};